/**
 * Created by xuyq on 2022/7/7.
 */
import axios from 'axios'
import {request as coreRequest, router, authV2,getToken } from '@/myops/core'
import { settings } from '@/myops/core'
let request

if (window.globalConfig.TYPE === "bot") {
  console.log(window.globalConfig.TYPE , '==============' , window.globalConfig.TYPE === "bot")
  // 创建axios实例
  let botRequest  = axios.create({
    withCredentials: false, // 请求是否带cookie
    // 设置默认的基础URL，所有相对路径都会基于此URL
    baseURL: 'https://cssa.accenture.cn/',
    // 设置默认的请求超时时间（毫秒）
    timeout: 5000,
    // 设置默认的请求头
    headers: {
      'Content-Type': 'application/json',
      'client': 'BookSeatClient',
      'client-secret': '^RRR6Rz1XMp1BPqPB5pPF1FBXTq5RMX'
    },
  })

  botRequest .interceptors.request.eject(0)

  botRequest .interceptors.request.use(async config => {
    console.log()
    let accessToken = ''
    let idToken = ''

    config.timeout = settings.request.timeout
    config.baseURL = "https://cssa.accenture.cn/"
    config.headers[settings.request.tokenId] = window.globalConfig.Auth_token
    // 为get请求添加时间戳,为了避免ie下get请求缓存
    if (config.method === 'get') {
      config.params = config.params || {}
      if (typeof config.params === 'string') {
        config.url += '?t=' + new Date().getTime()
      } else {
        config.params['t'] = new Date().getTime()
      }
    }
    // 发送request之前拦截请求,并添加token
    // config.headers['Authorization'] = idToken
    console.log('****accessToken*****', accessToken)

    // config.headers[settings.request.tokenId] = 'eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJpc3N1ZXIiLCJhdWQiOiJhdWRpZW5jZSIsInVzZXJfaWQiOiIxMzg0MDgwNyIsInRva2VuX3R5cGUiOiJhY2Nlc3NfdG9rZW4iLCJ1c2VyX2Rpc3BsYXlfbmFtZSI6IkxvbmdoYW8gWmhhbyDvvIjotbXpvpnmmIrvvIkiLCJhY2NvdW50IjoibG9uZ2hhby56aGFvIiwiZXhwIjoxNzYwNjg0MDQxLCJuYmYiOjE3NjA0MjQ4NDF9.RbDmsnnWFifUhQUsklWnAUlNRP0ol-QZhniCQPmynm4'
    config.headers['Token-Type'] = settings.request.tokenType
    config.headers['language'] = localStorage.getItem('language') || 'en'
    // 客户端IP
    config.headers['common'] = {
      Pragma: 'no-cache',
      'Cache-Control': 'no-cache'
    }
    // config.startTime = new Date()
    return config
  }, error => {
    // 请求错误处理
    console.error(error) // for debug
    Promise.reject(error)
  })




  // 500 跳错误页
  botRequest.interceptors.response.use(
    res => {
      return res
    },
    res => {
      // if (res.response.status === 500 || res.response.data.code === 500) {
      //   router.push('/other/error')
      // }
      if (res.response.status === 601 || res.response.data.code === 601) {
        router.push('/other/noPermission')
      }
      return Promise.reject(res)
    },
  )

  request = botRequest
} else {
  const enhancedRequest = coreRequest
  enhancedRequest.interceptors.request.eject(0)

  enhancedRequest.interceptors.request.use(async config => {
    let accessToken = ''
    let idToken = ''

    if (settings.isESO && config.url.indexOf('open-api') < 0) {
      let tokenResponse = await authV2.acquireToken()
      if (tokenResponse) {
        accessToken = tokenResponse.accessToken
        idToken = `Bearer ${tokenResponse.idToken}`
      } else {
        return null
      }
      // idToken = localStorage.getItem("Authorization")
      // accessToken = localStorage.getItem("auth-token")
      // if(!accessToken){
      //   // 重新调用路由
      //   console.log('重新调用路由 process.env.VUE_APP_REDIRECT + "anonymous"',process.env.VUE_APP_REDIRECT + "anonymous")
      //   const ref = process.env.VUE_APP_REDIRECT + "anonymous"
      //   const loginUrl = `https://myopsnext.accenture.cn/login/?redirect=${btoa(ref)}&cache=y`
      //   location.replace(loginUrl)
      // }
    } else {
      accessToken = getToken()
    }
    config.timeout = settings.request.timeout
    config.baseURL = settings.request.base_url
    config.headers[settings.request.tokenId] = accessToken

    // 为get请求添加时间戳,为了避免ie下get请求缓存
    if (config.method === 'get') {
      config.params = config.params || {}
      if (typeof config.params === 'string') {
        config.url += '?t=' + new Date().getTime()
      } else {
        config.params['t'] = new Date().getTime()
      }
    }
    // 发送request之前拦截请求,并添加token
    // config.headers['Authorization'] = idToken
    console.log('****accessToken*****', accessToken)

    // config.headers[settings.request.tokenId] = 'eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJpc3N1ZXIiLCJhdWQiOiJhdWRpZW5jZSIsInVzZXJfaWQiOiIxMzg0MDgwNyIsInRva2VuX3R5cGUiOiJhY2Nlc3NfdG9rZW4iLCJ1c2VyX2Rpc3BsYXlfbmFtZSI6IkxvbmdoYW8gWmhhbyDvvIjotbXpvpnmmIrvvIkiLCJhY2NvdW50IjoibG9uZ2hhby56aGFvIiwiZXhwIjoxNzYwNjg0MDQxLCJuYmYiOjE3NjA0MjQ4NDF9.RbDmsnnWFifUhQUsklWnAUlNRP0ol-QZhniCQPmynm4'
    config.headers['Token-Type'] = settings.request.tokenType
    config.headers['language'] = localStorage.getItem('language') || 'en'
    // 客户端IP
    config.headers['common'] = {
      Pragma: 'no-cache',
      'Cache-Control': 'no-cache'
    }
    // config.startTime = new Date()
    return config
  }, error => {
    // 请求错误处理
    console.error(error) // for debug
    Promise.reject(error)
  })
  // 500 跳错误页
  enhancedRequest.interceptors.response.use(
    res => {
      return res
    },
    res => {
      // if (res.response.status === 500 || res.response.data.code === 500) {
      //   router.push('/other/error')
      // }
      if (res.response.status === 601 || res.response.data.code === 601) {
        router.push('/other/noPermission')
      }
      return Promise.reject(res)
    },
  )
  request = enhancedRequest
}


export default request
